module.exports = __webpack_public_path__ + "assets/img/panel-owner.07813a92.jpg";